'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import { loadOpentopoLayer, loadSatelliteLayer, loadMaptilerLayer } from './MapLayers';

const DEFAULT_ZOOM_LEVEL = 12;

export default class EventMap extends React.Component {
  static propTypes = {
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props);
    this.map = null;
  }

  mapOptions() {
    return {};
  }

  setMarker() {
    const posLatLng = [this.props.lat, this.props.lng];
    return L.marker(posLatLng).addTo(this.map);
  }

  componentDidMount() {
    this.renderMap();
  }

  renderMap() {
    const maptilerLayer = loadMaptilerLayer();
    const topoLayer = loadOpentopoLayer();
    const satelliteLayer = loadSatelliteLayer();

    this.map = L.map(this.refs.map, {
      zoom: DEFAULT_ZOOM_LEVEL,
      layers: [maptilerLayer],
      preferCanvas: true,
    }).setView([this.props.lat, this.props.lng], DEFAULT_ZOOM_LEVEL);
    const baseMaps = {
      'Swisstopo': maptilerLayer,
      'Opentopo': topoLayer,
      'Satellite': satelliteLayer,
    };
    L.control.layers(baseMaps).addTo(this.map);
    this.marker = this.setMarker();
  }

  render() {
    return (
      <div>
        <div ref="map" style={{ height: '350px', width: '100%' }} />
      </div>
    );
  }
}
